import { render, staticRenderFns } from "./ClasificacionArtistasPorSeguidores.vue?vue&type=template&id=bea473f6&"
import script from "./ClasificacionArtistasPorSeguidores.vue?vue&type=script&lang=js&"
export * from "./ClasificacionArtistasPorSeguidores.vue?vue&type=script&lang=js&"
import style0 from "./ClasificacionArtistasPorSeguidores.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports